import React, { useEffect, useRef, useState } from 'react';
import { Block, Text, Tag } from '../../../../components';
import iconInfo from '../../../../../assets/icons/info-grey.svg';
import iconLaptopImage from '../../../../../assets/icons/icon-laptop-bg-black.svg';
import TextHelper from '@/core/helpers/TextHelper';
import {
  Contenedor1,
  Contenedor2,
  MainContainer,
  TitleText
} from './Components';
import LegendComponent from './LegendComponent';
import { InteractiveButton } from '@/presentation/modules/procedures/components';
import IDHelpers from '@/core/helpers/IDHelper';

const ContainerSchedule = (props: any) => {
  const { ScheduleResumeHome, handlerRedirectNewPage } = props;
  const [heightVirtual, setHeightVirtual] = useState(0);
  const isDesdob = ScheduleResumeHome?.find((e: any) => e.desdobGroup);
  const ref: any = useRef();
  const virtual24Pre =
    ScheduleResumeHome &&
    ScheduleResumeHome.filter((day: any) => day.type === 'Virtual 24/7');

  const virtual24 = virtual24Pre?.filter(
    (item: any, index: number) =>
      virtual24Pre.indexOf(
        virtual24Pre.find((v: any) => v.courseId === item.courseId)
      ) === index
  );

  const evalVirtual24 = () => {
    if (!virtual24 || virtual24.length === 0) return { start: null, end: null };
    const size = Math.round((virtual24 as Array<any>).length / 2);
    const start = virtual24.slice(0, size);
    const end = virtual24.slice(size);
    return { start, end };
  };

  const { start, end } = evalVirtual24();
  const days = [
    { day: '1', name: 'Lun' },
    { day: '2', name: 'Mar' },
    { day: '3', name: 'Mié' },
    { day: '4', name: 'Jue' },
    { day: '5', name: 'Vie' },
    { day: '6', name: 'Sáb' },
    { day: '7', name: 'Dom' }
  ];

  // Get max number of courses by day
  const maxCoursesLength = ScheduleResumeHome?.filter(
    ({ type }: any) => type !== 'Virtual 24/7'
  ).map((item: any) => item.day);

  maxCoursesLength?.sort();
  const uniques = Array.from(new Set(maxCoursesLength));
  const counts = uniques.map(
    (item) => maxCoursesLength?.filter((f: any) => f === item)?.length
  );
  const maxCoursesByDay = Number(Math.max(...counts));

  useEffect(() => {
    if (virtual24 && virtual24.length > 0)
      setHeightVirtual(ref.current.clientHeight);
  }, [virtual24]);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <MainContainer data-testid="cmp-main-container">
        <div className="headerContainer">
          <Text
            color={'#161D1F'}
            fontSize={'18px'}
            fontWeight={700}
            level={1}
            style={{ marginBottom: '6px' }}
          >
            Mi último horario matriculado
          </Text>
        </div>
        {isDesdob && (
          <div
            style={{
              display: 'flex',
              marginTop: 6
            }}
          >
            <div className="hasRelatedCourses">
              <img src={iconInfo} alt="other" />
              <span>
                Recuerda que dentro de tu horario tienes cursos con sesiones de
                laboratorio. El horario y la ubicación podrían variar entre
                semanas.
              </span>
            </div>
          </div>
        )}
        <div style={{ position: 'relative', width: 1125 }}>
          <div className="gridContainer">
            <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
              {days.map((d) => (
                <Contenedor1
                  maxCoursesByDay={maxCoursesByDay}
                  key={IDHelpers.generateID()}
                >
                  <TitleText
                    text={d.name}
                    style={{ marginBottom: heightVirtual + 25 }}
                  />
                  {ScheduleResumeHome &&
                    ScheduleResumeHome.filter(
                      ({ day, type }: any) =>
                        day === d.day && type !== 'Virtual 24/7'
                    )
                      .sort(
                        (a: any, b: any) =>
                          Number(a.start.replace(':', '')) -
                          Number(b.start.replace(':', ''))
                      )
                      .map((currentDate: any) => (
                        <Contenedor2
                          key={IDHelpers.generateID()}
                          currentDate={currentDate}
                          virtual24={virtual24}
                          handlerRedirectNewPage={handlerRedirectNewPage}
                        />
                      ))}
                </Contenedor1>
              ))}
            </div>
            <LegendComponent />
          </div>

          {virtual24 && virtual24.length >= 1 && (
            <div className="virtualContainer" ref={ref}>
              <InteractiveButton
                bkgColorEnabled="#ffffff"
                bkgColorHover="#D5E5F0"
                bkgColorFocus="#A8CBE2"
                bkgColorPressed="#A8CBE2"
                width="1108px"
                padding="8px"
                // margin={${virtual24.length > 0 ? '0px' : '32px'} 0px 12px 0px}
                customized
                onClick={() =>
                  handlerRedirectNewPage('https://class.utp.edu.pe/')
                }
                backgroundColor="#fff"
                borderRadius="4px"
                display="flex"
                // justifyContent="flex-start"
                alignItems="center"
                shadow="1px 4px 8px -7px var(--neutral-01)"
                // hasInteraction={hasInteraction}
              >
                <Block
                  customized
                  display="flex"
                  alignItems="center"
                  alignContent="center"
                >
                  <Block
                    customized
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    alignContent="center"
                  >
                    <Tag
                      backgroundColor={'#B21F5F'}
                      color={'#FFF8F7'}
                      margin="4px 12px 0px 8px"
                      padding="0 10px"
                      width="70px"
                      radius={20}
                      lineHeight={16}
                      size={12}
                      height={24}
                      center
                    >
                      {'Virtual 24/7'}
                    </Tag>
                    <Text color={'#161D1F'} fontSize={'12px'} fontWeight={400}>
                      {'Disponible las 24 horas durante el ciclo'}
                    </Text>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginLeft: 8
                      }}
                    >
                      <img alt="" src={iconLaptopImage} />
                      <Text
                        color={'#161D1F'}
                        fontSize={'12px'}
                        fontWeight={400}
                      >
                        {'UTP+class'}
                      </Text>
                    </div>
                  </Block>
                  <Block customized margin="8px 0px 0px 32px">
                    {/* <Text color={'#161D1F'} fontSize={'14px'} fontWeight={700}>
                    {'Cursos en esta modalidad'}
                  </Text> */}
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        marginTop: 3,
                        justifyContent: 'space-between',
                        textAlign: 'left'
                      }}
                    >
                      <ul
                        style={{
                          listStyleType: 'none',
                          marginLeft: '0',
                          width: '50%'
                        }}
                      >
                        {start?.map((sch: any) => (
                          <li key={sch.courseId}>
                            <b>{TextHelper.capitalize(sch.name)}</b>
                          </li>
                        ))}
                      </ul>
                      {end && end.length > 0 && (
                        <>
                          <div
                            style={{
                              backgroundColor: '#7A959F',
                              width: '2px',
                              marginRight: 8
                            }}
                          />
                          <ul
                            style={{ listStyleType: 'none', marginLeft: '5px' }}
                          >
                            {end?.map((sch: any) => (
                              <li key={sch.courseId}>
                                <b>{TextHelper.capitalize(sch.name)}</b>
                              </li>
                            ))}
                          </ul>
                        </>
                      )}
                    </div>
                  </Block>
                </Block>
              </InteractiveButton>
            </div>
          )}
        </div>
      </MainContainer>
    </div>
  );
};

export default ContainerSchedule;
